$(document).ready(function() {
  target = location.hash;
  if (target.length > 0) {
    var element = $('[name=' + target.slice(1) +']').closest('tr');
    element.addClass('highlight', 2000);
    element.removeClass('highlight', 1000);
  }
});
